import { render, staticRenderFns } from "./TopDataTable.vue?vue&type=template&id=3e230afe&scoped=true"
import script from "./TopDataTable.vue?vue&type=script&lang=js"
export * from "./TopDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e230afe",
  null
  
)

export default component.exports